import { useTranslations } from "next-intl"

import { ReducedProductData } from "@/lib/storefront/product/product"
import { calculateAvailabilityData } from "@/components/ui/helpers/product-availability-helper"
import ImageWithFallback from "@/components/storyblok/common/ImageWithFallback"

export function ProductCardDeliveryInfo(props: { productData: ReducedProductData | undefined; isoLocale: string }) {
  const t = useTranslations("storefront")

  const availabilityData = calculateAvailabilityData(props.isoLocale, props.productData, /*props.standardVariant,*/ t)
  const availabilityText = availabilityData.availabilityText ? "(" + availabilityData.availabilityText + ")" : ""

  return (
    <div className="text-wrap-balance flex items-center justify-start gap-2">
      <ImageWithFallback
        unoptimized={true}
        width={32}
        height={32}
        className={"aspect-square h-8 lg:h-6 xl:h-8"}
        alt={""}
        src={"/img/delivery.svg"}
      />
      <div className={"flex flex-col items-start justify-center"}>
        {props.productData?.availability === true ? (
          <>
            <p className={"text-xs leading-tight lg:text-[0.65em] xl:text-xs"}>
              {availabilityData.immediatelyAvailable ? t("product.available") : t("product.free_shipping")}
            </p>
            <p className={"text-xs leading-tight lg:text-[0.65em] xl:text-xs"}>{availabilityText}</p>
          </>
        ) : (
          <p className={"text-xs leading-tight lg:text-[0.65em] xl:text-xs"}>{t("product.delivery_time_unknown")}</p>
        )}
      </div>
    </div>
  )
}
